var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 80,
    viewBox: "0 0 75 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0893 0C22.3158 0 24.1071 1.78333 24.1071 4V10.6667H50.8929V4C50.8929 1.78333 52.6842 0 54.9107 0C57.1373 0 58.9286 1.78333 58.9286 4V10.6667H64.2857C70.1953 10.6667 75 15.45 75 21.3333V69.3333C75 75.2167 70.1953 80 64.2857 80H10.7143C4.80469 80 0 75.2167 0 69.3333V21.3333C0 15.45 4.80469 10.6667 10.7143 10.6667H16.0714V4C16.0714 1.78333 17.8627 0 20.0893 0ZM20.0893 18.6667H10.7143C9.24107 18.6667 8.03571 19.8667 8.03571 21.3333V29.3333H66.9643V21.3333C66.9643 19.8667 65.7589 18.6667 64.2857 18.6667H20.0893ZM8.03571 37.3333V69.3333C8.03571 70.8 9.24107 72 10.7143 72H64.2857C65.7589 72 66.9643 70.8 66.9643 69.3333V37.3333H8.03571Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderNew);
export default __webpack_public_path__ + "static/media/calender_new.1f0827725c4b93cc7073f94df60f1af6.svg";
export { ForwardRef as ReactComponent };